export default __webpack_public_path__ + "static/media/create_game.cb13b04e.png";